import React, { useContext, useState } from 'react'

import classNames from 'classnames'

import type { PortableTextComponentProps } from '~/components/atoms/BlockContent/BlockContent'
import BlockContent from '~/components/atoms/BlockContent/BlockContent'
import type { ImageProps } from '~/components/atoms/Image/Image'
import SlideOutPanel from '~/components/atoms/SlideOutPanel/SlideOutPanel'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import { GlobalStoreContext } from '~/contexts/GlobalStoreContext'
import { GlobalStoreProps } from '~/contexts/GlobalStoreReducer'
import { useMediaQuery } from '~/services/useMediaQuery'
import bp from '~/styles/breakpoints/breakpoints'

import ImageRelative from '../../components/ImageRelative/ImageRelative'
import ThemeContainer from '../../ThemeContainer/ThemeContainer'
import { ReportTheme } from '../../types'

import ReportAdvertForm from './ReportAdvertForm/ReportAdvertForm'

import styles from './ReportAdvert.module.css'

export interface IReportAdvert {
  title: string
  introduction?: PortableTextComponentProps['blocks']
  modalImage: ImageProps
  link?: string
}

export interface ReportAdvertProps extends IReportAdvert {
  children: React.ReactNode
}

export default function ReportAdvert({
  title,
  introduction,
  modalImage,
  children,
  link,
}: ReportAdvertProps) {
  const [isOpen, setIsOpen] = useState(false)
  const isLargeDevice = useMediaQuery(`(min-width: ${bp.bpMedium})`)
  const { stateDispatch } = useContext(GlobalStoreContext)

  const openTrayHandler = () => {
    if (link) {
      window.open(link, '_blank')
      return
    }

    stateDispatch({
      type: GlobalStoreProps.UPDATE_PREVENT_PAGE_SCROLL,
      payload: true,
    })
    setIsOpen(true)
  }

  const closeTrayHandler = () => {
    stateDispatch({
      type: GlobalStoreProps.UPDATE_PREVENT_PAGE_SCROLL,
      payload: false,
    })
    setIsOpen(false)
  }

  return (
    <>
      <div onClick={() => openTrayHandler()} className={styles.base}>
        {children}
      </div>
      <SlideOutPanel
        isShowing={isOpen}
        fullWidth={!isLargeDevice}
        closeHandler={closeTrayHandler}
        title={
          <div className={styles.slideoutTitleContainer}>
            <Text
              size={TextSizes.primaryTitleMed}
              className={styles.slideoutTitle}
            >
              <em>My</em>Artbroker.
            </Text>
            <Text className={styles.slideoutSubTitle}>Partner</Text>
          </div>
        }
        theme={ReportTheme.quaternary}
        inlineTitleWithClose
      >
        <ThemeContainer theme={ReportTheme.quaternary}>
          <div className={styles.slideoutContainer}>
            {modalImage && (
              <ImageRelative image={modalImage} marginBottom={false} />
            )}
            <Text
              size={TextSizes.magPrimaryTitleMed}
              className={styles.slideoutContainerTitle}
            >
              {title}
            </Text>
            {introduction && (
              <div className={classNames(styles.introduction)}>
                <BlockContent value={introduction} size={TextSizes.bodyMed} />
              </div>
            )}
            <ReportAdvertForm formOpen={isOpen} />
          </div>
        </ThemeContainer>
      </SlideOutPanel>
    </>
  )
}
